module.exports = __webpack_public_path__ + "static/media/monitor-button1.2678dd83.png";